export const rateTypeFlat = () => {
    return 1 as const;
};

export const rateTypeDependent = () => {
    return 2 as const;
};

export const rateTypeVolume = () => {
    return 3 as const;
};

export const rateTypeFSASelectMatch = () => {
    return 4 as const;
};